import { Action } from '../actions/ActionInterface';
import { beerDataReducer, BeerDataState } from './beerDataReducer';
import { filtersReducer, FiltersState } from './filtersReducer';
import { userInteractionsReducer, UserInteractionsState } from './userInteractionsReducer';
import { uiStateReducer, UiState } from './uiStateReducer';
import { BeerState } from '../types';

/**
 * Root reducer that combines all domain-specific reducers
 * This follows the Composite pattern to create a unified state management approach
 * while maintaining separation of concerns
 */
export function rootReducer(state: BeerState | undefined, action: Action): BeerState {
  // console.log('[rootReducer] Processing action:', action.type);
  if (state === undefined) {
    // console.log('[rootReducer] Initializing state with defaults');
    // Initialize state with defaults from each reducer
    return {
      beers: [],
      loading: false,
      error: null,
      filters: filtersReducer(undefined, { type: '' } as any),
      userInteractions: userInteractionsReducer(undefined, { type: '' } as any),
      ui: uiStateReducer(undefined, { type: '' } as any),
      activeTab: '0', // For backward compatibility
    };
  }

  // Extract the parts of state each reducer is responsible for
  const beerDataState: BeerDataState = {
    beers: state.beers,
    loading: state.loading,
    error: state.error,
  };
  
  const filtersState: FiltersState = state.filters;
  const userInteractionsState: UserInteractionsState = state.userInteractions;
  const uiState: UiState = state.ui;
  
  // Apply each reducer to its part of the state
  const beerDataResult = beerDataReducer(beerDataState, action);
  const filtersResult = filtersReducer(filtersState, action);
  const userInteractionsResult = userInteractionsReducer(userInteractionsState, action);
  const uiResult = uiStateReducer(uiState, action);
  
  // console.log('[rootReducer] Results from reducers:', {
  //   beerDataBeersLength: beerDataResult.beers?.length || 0,
  //   beerDataLoading: beerDataResult.loading,
  //   filtersChanged: filtersResult !== filtersState,
  //   userInteractionsChanged: userInteractionsResult !== userInteractionsState,
  //   uiChanged: uiResult !== uiState
  // });
  
  const result = {
    ...beerDataResult,
    filters: filtersResult,
    userInteractions: userInteractionsResult,
    ui: uiResult,
  };
  
  // console.log('[rootReducer] Final combined state:', {
  //   beersLength: result.beers?.length || 0,
  //   loading: result.loading,
  //   error: result.error,
  //   filters: Object.keys(result.filters || {}),
  //   userInteractions: Object.keys(result.userInteractions || {}),
  //   ui: Object.keys(result.ui || {})
  // });
  
  return result;
}
